// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"IPRPage_paginationWrapper__fZyMf"};